/**
 * Created by apokdev on 6/8/17.
 */
import React, {Component} from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Buscar from './components/Buscar';
import PrivacyPolicy from "./components/PrivacyPolicy";
import Regiones from './components/Regiones';
import PoiInfo from './components/PoiInfo';
import EstadoInfo from './components/EstadoInfo';
import PoisEstado from './components/PoisEstado';
import Rutas from './components/Rutas';
import RutaInfo from './components/RutaInfo';
import ContactoForm from './components/ContactoForm';
import createHistory from 'history/createHashHistory';
import {routeChanged} from './constants/functions';

export default class extends Component{
    constructor(props){
        super(props);
        this.history = createHistory();
        this.history.listen((location, action) => {
            routeChanged(location.pathname || '');
        })
    }
    render(){
        return <HashRouter>
            <Switch>
                <Route exact path="/" component={Regiones}/>
                <Route path="/region/:regionSlug" component={Regiones}/>
                <Route path="/buscar" component={Buscar}/>

                <Route path="/poi/:poiId" component={PoiInfo}/>

                <Route exact path="/estado/:estado/sector/:sector/:tipopoi?" component={PoisEstado}/>
                <Route exact path="/estado/:estado/rutas/:sector?" component={Rutas} />
                <Route exact path="/estado/:estado/:tipopoi" component={PoisEstado} />
                <Route exact path="/estado/:estado" component={EstadoInfo}/>

                <Route path="/ruta/:rutaId" component={RutaInfo} />
                <Route path="/contacto" component={ContactoForm} />
                <Route path="/privacidad" component={PrivacyPolicy} />
                <Route render={() => <span>404</span>}/>
            </Switch>
        </HashRouter>
    }
}



// WEBPACK FOOTER //
// ./src/App.js